import { useEffect, useRef } from 'react';
import { PHONE_1 } from '../../../components/feature/TopBar';

const WA_LINK = `https://wa.me/90${PHONE_1}?text=${encodeURIComponent('Merhaba, uzman temizlik hizmeti için randevu almak istiyorum.')}`;

const mistakes = [
  {
    icon: 'ri-close-circle-fill',
    title: 'Leke Silmek Kiri İçeri İter',
    desc: 'Kumaşa baskı uygulayarak silmek, lekeyi derinden yayar ve çıkarmayı zorlaştırır.',
  },
  {
    icon: 'ri-close-circle-fill',
    title: 'Yanlış Kimyasal Kumaşa Zarar Verir',
    desc: 'Market ürünleri kumaş tipine uygun olmayabilir; solma, sertleşme ve bozulmaya yol açar.',
  },
  {
    icon: 'ri-close-circle-fill',
    title: 'İnternet Yöntemleri Sorunu Büyütür',
    desc: 'Sosyal medyadaki "ev yapımı" çözümler çoğunlukla profesyonel kumaşlar için test edilmemiştir.',
  },
  {
    icon: 'ri-close-circle-fill',
    title: 'Yanlış Müdahale Temizliği Zorlaştırır',
    desc: 'İlk müdahaledeki hatalar, sonraki profesyonel temizliği çok daha güçleştirir.',
  },
];

export default function WarningSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) el.classList.add('opacity-100', 'translate-y-0'); },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="w-full bg-[#1a1a1a] py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4">
        <div
          ref={ref}
          className="opacity-0 translate-y-8 transition-all duration-700"
        >
          {/* Title */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-2 rounded-full text-sm font-semibold mb-5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-error-warning-fill" />
              </span>
              Dikkat
            </div>
            <h2
              className="text-3xl md:text-5xl font-extrabold text-white leading-tight"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              Temizlik Yaparken Daha Fazla
              <br />
              <span className="text-red-400">Zarar Veriyor Olabilirsiniz</span>
            </h2>
            <p className="text-gray-400 mt-4 text-base md:text-lg max-w-2xl mx-auto">
              Evde yapılan yanlış müdahaleler, lekeleri kalıcı hale getirebilir.
            </p>
          </div>

          {/* Mistakes Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
            {mistakes.map((m) => (
              <div
                key={m.title}
                className="bg-white/5 border border-white/10 rounded-2xl p-6 flex gap-4 hover:-translate-y-1 transition-transform duration-300 group"
              >
                <span className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className={`${m.icon} text-red-400 text-2xl`} />
                </span>
                <div>
                  <h3 className="text-white font-bold text-base mb-1 group-hover:text-red-300 transition-colors">{m.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{m.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center">
            <a
              href={WA_LINK}
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white font-bold text-lg px-10 py-4 rounded-xl transition-all hover:scale-105 shadow-lg shadow-emerald-500/30 whitespace-nowrap animate-pulse hover:animate-none"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line" />
              </span>
              Uzman Temizlik İçin Hemen Randevu Al
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
